let tipFlag = true
let cusTipFlag = true 
function PublicNewMsg(data, that,flag) { 
    console.log('全局消息result：',JSON.parse(data).result)
    let end = JSON.parse(data) 
    end.noShowMessageBox = false
    if(flag){
        //更新列表，不弹出消息列表
        end.noShowMessageBox = true
    }
    that.$websocket.dispatch("getMessageNumber", end);
    return
    let num = 0;
    let oldNum = localStorage.getItem('oldNum')
    if (typeof data === "string") {
        num = JSON.parse(data).intoCaseMsgNumber;
        that.$websocket.dispatch("getMessageNumber", num);
    } else {
        that.$websocket.dispatch("getMessageNumber", data);
        num = data.intoCaseMsgNumber
    }
    if (num <= oldNum) {
        //更新已读状态时
        localStorage.setItem('oldNum', num)
    }
    if (num > oldNum) {
        //首次进入未未存oldNum null
        if (tipFlag) {
            that.$notify.success({
                title: "通知",
                message: "您有新的消息，请注意查看！",
                showClose: false,
                position: "top-right",
                duration: 4000
            });
            localStorage.setItem('oldNum', num)
            tipFlag = false
            setTimeout(() => {
                tipFlag = true;
            }, 4100);
        }
    }
    
}

function PublicOpinionFeedback(data, that) {
    if (localStorage.getItem('Authorization')) {
        if (typeof data === "string") {
            that.$websocket.dispatch(
                "getOpinionFeedbackNum",
                JSON.parse(data).opinionFeedbackNumber
            );
        } else {
            that.$websocket.dispatch(
                "getOpinionFeedbackNum",
                data.opinionFeedbackNumber
            );
        }
    }
}

function PublicCustomerService(data, that) {
    if (localStorage.getItem('Authorization')) {
        let cusNum = 0
        let oldCusNum = localStorage.getItem('oldCusNum') 
        if (typeof data === "string") {
            cusNum= JSON.parse(data).customerServiceNumber
            that.$websocket.dispatch(
                "getCustomerNum",
                JSON.parse(data).customerServiceNumber
            );
        } else {
            that.$websocket.dispatch(
                "getCustomerNum",
                data.customerServiceNumber
            );
        }
        if (cusNum <= oldCusNum) {
            //更新已读状态时
            localStorage.setItem('oldCusNum', cusNum)
        }
        if (cusNum > oldCusNum) { 
            if (cusTipFlag) {
                that.$notify.success({
                    title: "通知",
                    message: "您有新的客服消息，请注意查看！",
                    showClose: false,
                    position: "top-right",
                    duration: 3000
                });
                localStorage.setItem('oldCusNum', cusNum)
                cusTipFlag = false
                setTimeout(() => {
                    cusTipFlag = true;
                }, 4100);
            }
        } 
    }
}
export {
    PublicNewMsg,
    PublicOpinionFeedback,
    PublicCustomerService
}